"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CannabisWeightFilterOption = void 0;
const mobx_1 = require("mobx");
const products_1 = require("@getgreenline/products");
const vocabularies_1 = require("../../vocabularies");
const quantityHelpers_1 = require("../../helpers/quantityHelpers");
class CannabisWeightFilterOption {
    constructor() {
        this.setMin = (weight) => {
            this.min = weight;
        };
        this.setMax = (weight) => {
            this.max = weight;
        };
        this.reset = () => {
            this.min = undefined;
            this.max = undefined;
        };
        this.isInRange = (cannabisWeight) => {
            if (cannabisWeight === null)
                return false;
            return (0, quantityHelpers_1.checkRange)(cannabisWeight, this.min, this.max);
        };
    }
    get isSet() {
        return Boolean(this.min || this.max);
    }
    get rangeMessage() {
        if (!this.min && !this.max) {
            return;
        }
        if (this.min && !this.max) {
            return `${this.min}${products_1.UnitModels.WeightUnit.G} ~ ${vocabularies_1.FilterVocabulary.UNLIMITED}`;
        }
        if (!this.min && this.max) {
            return `0${products_1.UnitModels.WeightUnit.G} ~ ${this.max}${products_1.UnitModels.WeightUnit.G}`;
        }
        return `${this.min || 0}${products_1.UnitModels.WeightUnit.G} ~ ${this.max || 0}${products_1.UnitModels.WeightUnit.G}`;
    }
}
exports.CannabisWeightFilterOption = CannabisWeightFilterOption;
__decorate([
    mobx_1.observable,
    __metadata("design:type", Number)
], CannabisWeightFilterOption.prototype, "min", void 0);
__decorate([
    mobx_1.observable,
    __metadata("design:type", Number)
], CannabisWeightFilterOption.prototype, "max", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], CannabisWeightFilterOption.prototype, "setMin", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], CannabisWeightFilterOption.prototype, "setMax", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], CannabisWeightFilterOption.prototype, "reset", void 0);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], CannabisWeightFilterOption.prototype, "isSet", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], CannabisWeightFilterOption.prototype, "rangeMessage", null);
//# sourceMappingURL=CannabisWeightFilterOption.js.map